import { cn } from '../../../../lib/styles';
import { trimNodeID } from '../../hooks/use-section-tree-mutations';
import type { SectionTreeNodeType } from '../../types/section-tree';
import { CompanyUserCard } from '../company-user-card';

const CustomerNodeType: SectionTreeNodeType = ({ type, selected, ...props }) => {
  const pid = trimNodeID(props.id);
  if (!('email' in props) || !pid || pid.type !== 'customer') {
    return null;
  }
  return (
    <div className={cn('min-w-60', selected && 'rounded-xl shadow shadow-spark-purple')}>
      <CompanyUserCard customer={{ ...props, id: pid.id }} />
    </div>
  );
};
export default CustomerNodeType;
